// extracted by mini-css-extract-plugin
export default {"list":"index_list_0FTJJ","time":"index_time_gw4oL","title":"index_title_gFfxc","timeTit":"index_timeTit_sZHis","more":"index_more_xKgbr","all":"index_all_pAGIN"};